import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sim-card-detail" }
const _hoisted_2 = {
  key: 0,
  class: "usage-charts"
}

import { ref, onMounted, onUnmounted, computed, watch, nextTick } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import apiClient from "@/services/apiClient";
import { API_URLS } from "@/config";
import * as echarts from "echarts";


export default /*@__PURE__*/_defineComponent({
  __name: 'SimCardDetail',
  props: {
    cardId: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const loading = ref(false);
const info = ref<any>({});
const usageLogs = ref<any[]>([]);
const usageChart = ref<HTMLElement | null>(null);
let chartInstance: echarts.ECharts | null = null;

const statusType = computed(() => {
  const status = info.value.account_status;
  if (status === "00" || status === "0") return "success";
  if (["08", "09", "11", "8", "9"].includes(status)) return "warning";
  return "danger";
});

const isSuperAdmin = computed(() => {
  return (store.state as any).user?.role === "super_admin";
});

const handleDiagnosis = () => {
  ElMessage.success("正在对卡片进行智能诊断...");
  // 模拟诊断逻辑
  setTimeout(() => {
    ElMessage.success("诊断完成：网络状态良好，套餐余量充足。");
  }, 1500);
};

const handleSync = async () => {
  if (!props.cardId) return;
  try {
    const response = await apiClient.post(
      API_URLS.SIM_CARD_SYNC(info.value.iccid || props.cardId)
    );
    if (response.data.code === 0) {
      ElMessage.success("同步成功");
      fetchData();
    }
  } catch (error) {
    ElMessage.error("同步失败");
  }
};

const fetchData = async () => {
  if (!props.cardId) return;
  loading.value = true;
  try {
    const response = await apiClient.get(
      API_URLS.SIM_CARD_DETAIL(props.cardId)
    );
    if (response.data.code === 0) {
      info.value = response.data.data.info || {};
      usageLogs.value = response.data.data.usage_logs || [];
      await nextTick();
      initChart();
    }
  } catch (error) {
    console.error("获取卡详情失败:", error);
  } finally {
    loading.value = false;
  }
};

const initChart = () => {
  if (!usageChart.value || usageLogs.value.length === 0) return;

  if (!chartInstance) {
    chartInstance = echarts.init(usageChart.value);
  }

  const data = usageLogs.value
    .map((log) => ({
      date: log.date,
      value: parseFloat(log.usage || "0"),
    }))
    .sort((a, b) => a.date.localeCompare(b.date));

  const option = {
    tooltip: {
      trigger: "axis",
      formatter: "{b}: {c} MB",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: data.map((d) => d.date),
    },
    yAxis: {
      type: "value",
      name: "流量 (MB)",
    },
    series: [
      {
        name: "用量",
        type: "line",
        smooth: true,
        data: data.map((d) => d.value),
        areaStyle: {
          opacity: 0.3,
        },
        itemStyle: {
          color: "#409EFF",
        },
      },
    ],
  };

  chartInstance.setOption(option);
};

const handleResize = () => {
  chartInstance?.resize();
};

onMounted(() => {
  fetchData();
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  if (chartInstance) {
    chartInstance.dispose();
    chartInstance = null;
  }
});

watch(
  () => props.cardId,
  () => {
    fetchData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_descriptions, {
      title: "基本信息",
      column: 3,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, { label: "ICCID" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.iccid || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "IMSI" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.imsi || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "MSISDN" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.msisdn || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "运营商" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.operator || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "状态" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tag, {
              type: statusType.value,
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(info.value.status || "未知"), 1)
              ]),
              _: 1
            }, 8, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "计费组" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.billing_group_name || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "总流量" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.total_quota ?? 0) + " MB", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "已用流量" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.used_data ?? 0) + " MB", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "剩余流量" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.remaining_data ?? 0) + " MB", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "激活时间" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.active_time || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "过期时间" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.expire_time || "-"), 1)
          ]),
          _: 1
        }),
        (isSuperAdmin.value)
          ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "操作"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: handleDiagnosis
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("智能诊断", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "success",
                      size: "small",
                      onClick: handleSync
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("同步数据", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (usageLogs.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "chart-title" }, "每日用量 (MB)", -1)),
          _createElementVNode("div", {
            ref_key: "usageChart",
            ref: usageChart,
            class: "chart-container"
          }, null, 512)
        ]))
      : (!loading.value)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无用量日志"
          }))
        : _createCommentVNode("", true)
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})